import { FC } from 'react';
import * as Icon from 'react-feather';
import { colorTableOperationIcon } from '@atlas-frontend/design-tokens';
import { Popconfirm, PopconfirmProps } from '../../../components';
import { TableOperationButton } from '../TableOperationButton';
import { ButtonProps } from 'antd';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './DeleteTableRowButton.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'delete-table-row-button',
);
addTranslations(translations);

export type DeleteTableRowButtonProps = ButtonProps & {
  confirm?:
    | boolean
    | (Partial<PopconfirmProps> &
        (
          | {
              isOpen: boolean;
              onOpenChange: (isOpen: boolean) => void;
            }
          | {
              isOpen?: never;
              onOpenChange?: never;
            }
        ));
};

export const DeleteTableRowButton: FC<DeleteTableRowButtonProps> = (props) => {
  const { t } = useTranslation();
  const { title = t('button.delete'), id, confirm = true, ...rest } = props;

  const button = (
    <TableOperationButton
      id={id}
      title={title}
      icon={<Icon.Trash2 size={18} color={colorTableOperationIcon} />}
      type="text"
      aria-label={title}
      {...rest}
    />
  );

  if (!confirm) {
    return button;
  }

  return (
    <Popconfirm
      id={`${id}-confirm`}
      title={t('confirm.title')}
      description={t('confirm.description')}
      okText={t('confirm.button.yes')}
      cancelText={t('confirm.button.no')}
      placement="bottom-end"
      {...(typeof confirm === 'object' && confirm)}
    >
      {button}
    </Popconfirm>
  );
};
